import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/site/PageHero";
import FunnelsAds from "../components/site/FunnelsAds";
import Process from "../components/site/Process";
import Problem from "../components/site/Problem";
import FinalCTA from "../components/site/FinalCTA";
import { usePageSEO, breadcrumb, serviceSchema } from "../hooks/usePageSEO";

export default function FunnelsPage() {
  usePageSEO({
    title: "Funnels de Venta y Automatización | Daos Ads",
    description:
      "Diseño e implemento funnels de adquisición end-to-end: tráfico (Google, Meta, TikTok), automatización con IA, calificación y cierre comercial. Sistema completo para empresas.",
    path: "/funnels",
    jsonLd: [
      breadcrumb([
        { name: "Inicio", path: "/" },
        { name: "Funnels", path: "/funnels" },
      ]),
      serviceSchema({
        name: "Funnels de venta end-to-end",
        description:
          "Diseño e implementación de funnels completos: tráfico pagado, automatización con IA, calificación y handoff comercial.",
        path: "/funnels",
      }),
    ],
  });

  return (
    <main>
      <PageHero
        eyebrow="Funnels & Adquisición"
        title="Un sistema completo, no campañas"
        highlight="sueltas"
        description="Tráfico pagado conectado a automatización, IA y un proceso comercial. Cada lead entra a una máquina diseñada para convertir, no a una bandeja olvidada."
        primaryCta={{ to: "/contacto", label: "Diseña mi sistema" }}
      />

      {/* Reuse the funnel visual */}
      <FunnelsAds />

      {/* Reuse the problem/pains section to give context */}
      <Problem />

      {/* Reuse process */}
      <Process />

      {/* Cross-links */}
      <section className="relative py-20">
        <div className="container-x">
          <div className="reveal max-w-2xl">
            <div className="eyebrow mb-5">Continúa explorando</div>
            <h2 className="font-display font-extrabold text-white text-3xl sm:text-4xl tracking-tighter leading-[1.05]">
              Cada vertical del <span className="text-gradient">funnel</span>.
            </h2>
          </div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { to: "/google-ads", label: "Google Ads", desc: "Captura intención de compra." },
              { to: "/meta-ads", label: "Meta Ads", desc: "Crea demanda y escala adquisición." },
              { to: "/tiktok-ads", label: "TikTok Ads", desc: "Adquisición moderna con creatividad." },
              { to: "/automatizacion-ia", label: "Automatización con IA", desc: "Califica y vende 24/7." },
            ].map((r) => (
              <Link key={r.to} to={r.to} className="reveal grad-border p-6 card-lift block">
                <div className="flex items-center justify-between">
                  <div className="text-white font-display font-semibold">{r.label}</div>
                  <ArrowUpRight className="w-5 h-5 text-zinc-400" />
                </div>
                <p className="mt-2 text-zinc-400 text-sm">{r.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </main>
  );
}
